import { connect } from 'react-redux'
import { selectPrefersReplyOpen } from 'ducks/currentUser/selectors'
import Button from './view'

const select = state => ({
  prefersOpen: selectPrefersReplyOpen(state),
})

export default connect(select)(Button)
